import { Component, OnInit } from '@angular/core';
import { FooterService, Footer } from './footer.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { Application } from '../../application/application';
import { AffiliateMarketingUrl } from '../../landing-pages/gift-card/gift-card';
import { ApplicationService } from '../../application/application.service';
import { TokenService } from '../../token/token.service';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';

declare var $: any;

@Component({
  selector: 'zest-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public footer: Footer;
  public application: Application;
  private walletTypeMerchantNames = ['amazonpay', 'flipkart'];
  private cancelledApplicationStatusMap = [2, 3, 5, 11, 12, 15, 18];
  private getApplicationAttempts = 20;

  constructor(private footerService: FooterService, private loaderService: LoaderService, private awsTrackingService: AwsTrackingService, private tokenService: TokenService, private applicationService: ApplicationService) {
    this.footerService.ShowFooterSource.subscribe(
      result => {
        this.footer = result;
      }
    );
  }

  ngOnInit() {
    this.footer = new Footer(false, false, false, false, false, false);
    const interval = setInterval(fn => {
      this.getApplicationAttempts--;
      this.application = this.applicationService.getApplication();
      if (this.application !== null) {
        clearInterval(interval);
      } else {
        if (this.getApplicationAttempts === 0) {
          clearInterval(interval);
        }
      }
    }, 200);
  }
  showModal() {
    if (this.footer.popup) {
      setTimeout(fn => { $('#backToMerchant').modal('open'); }, 0);
    } else {
      this.backToMerchant();
    }
  }
  closeModal() {
    setTimeout(fn => { $('#backToMerchant').modal('close'); }, 0);
  }
  backToMerchant() {
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    if (this.application && this.footer.backToMerchant) {
      if (this.footer.cancelOrder) {
        this.awsTrackingService.gtmTriggerEvent('Application-Customer-Cancelled');
        this.applicationService.changeApplicationStatus('CustomerCancelled', this.application.ApplicationId).subscribe(response => {
          this.tokenService.cancel(this.application);
        }, error => {
          this.tokenService.cancel(this.application);
        });
      } else {
        if (this.walletTypeMerchantNames.indexOf(this.application.MerchantName.toLowerCase()) > -1) {
          this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
          window.open(AffiliateMarketingUrl[this.application.MerchantName.toLowerCase()], '_blank');
        } else {
          this.applicationService.getState(this.application.ApplicationId).subscribe(states => {
            if (this.cancelledApplicationStatusMap.indexOf(states.loan.CurrentStatus) > -1) {
              window.location.href = this.application.ReturnUrl;
            } else {
              window.location.href = this.application.ApprovedUrl;
            }
          });
        }
      }
    }
  }

}
